import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { updateData, addRequestsData } from '../../api/indexedDBHandler'

import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Modal,
  TextField,
  MenuItem,
  Button,
  Divider,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material'
import { Edit, Delete, FilterList } from '@mui/icons-material'

const Confirmed = ({ stage: propStage, all, func }) => {
  const [stage, setStage] = useState(propStage)
  const [editingFish, setEditingFish] = useState(null)
  const [fishType, setFishType] = useState('')
  const [fishWeight, setFishWeight] = useState(0)
  const [teamFilter, setTeamFilter] = useState('all')
  const [fishToDelete, setFishToDelete] = useState(null)
  //console.log(propStage)
  const { id } = useParams()

  useEffect(() => {
    setStage(propStage)
  }, [propStage]) // Зависимость от propStage

  // Получаем уникальные названия команд для фильтра
  const uniqueTeams = [
    'all',
    ...new Set(stage?.map((item) => item.teamName || 'Не указано')),
  ]

  // Фильтрация и сортировка данных
  const filteredData =
    stage
      ?.filter((item) => teamFilter === 'all' || item.teamName === teamFilter)
      ?.sort((a, b) => new Date(b.time) - new Date(a.time)) || []

  const handleEdit = (fish) => {
    setEditingFish(fish)
    setFishType(fish.type)
    setFishWeight(fish.weight)
  }

  const handleSave = async () => {
    const updatedStage = stage.map((item) => ({
      ...item,
      fishList: item.fishList.map((fish) =>
        fish.timestamp === editingFish.timestamp
          ? { ...fish, type: fishType, weight: fishWeight }
          : fish
      ),
      // Обновляем общий вес и количество
      totalWeight: item.fishList.reduce(
        (sum, fish) =>
          sum +
          (fish.timestamp === editingFish.timestamp ? fishWeight : fish.weight),
        0
      ),
      fishCount: item.fishList.filter(
        (fish) =>
          fish.weight > 0 ||
          (fish.timestamp === editingFish.timestamp && fishWeight > 0)
      ).length,
    }))

    const dataToUpdate = {
      id: id, // Используем переданный id
      items: updatedStage, // Обновленный массив
    }

    updateData('stage', id, dataToUpdate)
    //console.log('dataToUpdate', dataToUpdate)

    setStage(updatedStage)
    const updatedFishData = {
      id: id,
      idfish: editingFish.id, // предполагая, что у рыбы есть id
      type: fishType,
      weight: fishWeight,
      timestamp: editingFish.timestamp, // сохраняем оригинальный timestamp
      requestKey: `${editingFish.id}_updatedFishData_${new Date().getTime()}`,
    }
    //console.log('updatedFishData', updatedFishData)

    setEditingFish(null)
    await addRequestsData('requests', {
      url: 'tournaments/updStage.php',
      ...updatedFishData,
    })
    func(updatedStage)
  }

  const confirmDelete = (id) => {
    setFishToDelete(id)
  }

  const handleDelete = async () => {
    const updatedStage = stage.map((item) => ({
      ...item,
      fishList: item.fishList.filter((fish) => fish.id !== fishToDelete),
      // Обновляем общий вес и количество
      totalWeight: item.fishList
        .filter((fish) => fish.id !== fishToDelete)
        .reduce((sum, fish) => sum + fish.weight, 0),
      fishCount: item.fishList.filter(
        (fish) => fish.id !== fishToDelete && fish.weight > 0
      ).length,
    }))

    const dataToUpdate = {
      id: id, // Используем переданный id
      items: updatedStage, // Обновленный массив
    }

    updateData('stage', id, dataToUpdate)
    //console.log(updatedStage)
    setStage(updatedStage)
    setFishToDelete(null)
    const updatedFishData = {
      id: id,
      idfish: fishToDelete, // предполагая, что у рыбы есть id
      weight: 0,
      requestKey: `${fishToDelete}_updatedFishData2_${new Date().getTime()}`,
    }
    await addRequestsData('requests', {
      url: 'tournaments/dellStage.php',
      ...updatedFishData,
    })
    func(updatedStage)
  }

  const fishTypes = [
    { value: 'карп', label: 'Карп' },
    { value: 'амур', label: 'Амур' },
  ]

  if (!stage) return null

  return (
    <Box>
      {/* Фильтр по командам */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
        <FilterList color="action" />
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel>Команда</InputLabel>
          <Select
            value={teamFilter}
            label="Команда"
            onChange={(e) => setTeamFilter(e.target.value)}
          >
            {uniqueTeams.map((team) => (
              <MenuItem key={team} value={team}>
                {team === 'all' ? 'Все команды' : team}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Chip
          label={`Найдено: ${filteredData.length}`}
          color="info"
          variant="outlined"
        />
      </Box>

      <Paper
        sx={{
          maxHeight: 500,
          overflow: 'auto',
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {filteredData.length > 0 ? (
          <List>
            {filteredData.map((item, index) => (
              <Paper
                key={`${item.id}-${index}`}
                sx={{
                  mb: 2,
                  p: 2,
                  bgcolor:
                    index % 2 === 0 ? 'background.default' : 'background.paper',
                }}
              >
                <Typography variant="body2">
                  Команда: <strong>{item.teamName || 'Не указано'}</strong>
                </Typography>
                <Typography variant="body2">
                  Время взвешивания:{' '}
                  <strong>{new Date(item.time).toLocaleString()}</strong>
                </Typography>

                {item.totalWeight > 0 && (
                  <Typography variant="body2">
                    Количество: <strong>{item.fishCount}</strong>
                  </Typography>
                )}

                <Typography variant="body2">
                  Общий вес: <strong>{item.totalWeight}</strong>
                </Typography>

                {item.fishList &&
                  item.totalWeight > 0 &&
                  item.fishList.length > 0 && (
                    <Box mt={1}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        Пойманная рыба:
                      </Typography>
                      <List dense>
                        {item.fishList
                          .sort((a, b) => b.timestamp - a.timestamp)
                          .map((fish, fishIndex) => (
                            <ListItem
                              key={fishIndex}
                              secondaryAction={
                                <Box>
                                  <IconButton
                                    edge="end"
                                    onClick={() => handleEdit(fish)}
                                    color="primary"
                                    size="small"
                                  >
                                    <Edit fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    edge="end"
                                    onClick={() => confirmDelete(fish.id)}
                                    color="error"
                                    size="small"
                                  >
                                    <Delete fontSize="small" />
                                  </IconButton>
                                </Box>
                              }
                            >
                              <ListItemText
                                primary={`Тип: ${fish.type}, Вес: ${fish.weight}`}
                                secondary={`Время: ${new Date(fish.timestamp).toLocaleTimeString()}`}
                              />
                            </ListItem>
                          ))}
                      </List>
                    </Box>
                  )}
              </Paper>
            ))}
          </List>
        ) : (
          <Typography textAlign="center" p={2}>
            {teamFilter === 'all'
              ? 'Нет данных взвешивания'
              : `Нет данных для команды "${teamFilter}"`}
          </Typography>
        )}
      </Paper>

      {/* Модальное окно редактирования */}
      <Modal open={Boolean(editingFish)} onClose={() => setEditingFish(null)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,
            borderRadius: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Редактировать рыбу
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <FormControl fullWidth margin="normal">
            <InputLabel>Тип рыбы</InputLabel>
            <Select
              value={fishType}
              label="Тип рыбы"
              onChange={(e) => setFishType(e.target.value)}
            >
              {fishTypes.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            type="number"
            label="Вес"
            value={fishWeight}
            onChange={(e) => setFishWeight(Number(e.target.value))}
            fullWidth
            margin="normal"
            InputProps={{ inputProps: { min: 0 } }}
          />

          <Box
            sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 1 }}
          >
            <Button variant="outlined" onClick={() => setEditingFish(null)}>
              Отмена
            </Button>
            <Button variant="contained" onClick={handleSave} color="primary">
              Сохранить
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Диалог подтверждения удаления */}
      <Dialog
        open={Boolean(fishToDelete)}
        onClose={() => setFishToDelete(null)}
      >
        <DialogTitle>Подтверждение удаления</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Вы уверены, что хотите удалить эту запись о рыбе? Это действие
            нельзя отменить.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFishToDelete(null)}>Отмена</Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Удалить
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Confirmed
